import { isSupabaseConfigured, supabase } from "../lib/supabase";

const STORAGE_KEY = "almoune_customer_groups";

export const defaultGroups = [
  {
    id: "group-pro",
    name: "Professionnel",
    defaultDiscount: 0,
  },
  {
    id: "group-vip",
    name: "VIP",
    defaultDiscount: 0,
  }
];

const normalizeGroup = (g) => ({
  id: g.id || `grp-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  name: g.name || "",
  defaultDiscount: Number(g.defaultDiscount || 0),
});

const readCache = () => {
  if (typeof window === "undefined") return [...defaultGroups];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [...defaultGroups];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || !parsed.length) return [...defaultGroups];
    return parsed.map(normalizeGroup);
  } catch {
    return [...defaultGroups];
  }
};

const writeCache = (groups) => {
  const normalized = groups.map(normalizeGroup);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  }
  return normalized;
};

export const getCustomerGroups = () => readCache();

export const loadCustomerGroups = async () => {
  if (isSupabaseConfigured) {
    try {
      const { data, error } = await supabase.from("customer_groups").select("*");
      if (!error && data) {
        const mapped = data.map(row => ({
          id: row.id,
          name: row.name,
          defaultDiscount: Number(row.default_discount || 0)
        }));
        return writeCache(mapped);
      }
    } catch (err) {
      console.warn("Failed to load customer groups from Supabase", err);
    }
  }
  return readCache();
};

export const saveCustomerGroup = async (group) => {
  const normalized = normalizeGroup(group);
  
  if (isSupabaseConfigured) {
    try {
      await supabase.from("customer_groups").upsert({
        id: normalized.id,
        name: normalized.name,
        default_discount: normalized.defaultDiscount
      });
    } catch (err) {
      console.warn("Failed to save customer group to Supabase", err);
    }
  }

  const groups = readCache();
  const existing = groups.findIndex((g) => g.id === normalized.id);
  if (existing >= 0) {
    groups[existing] = normalized;
  } else {
    groups.push(normalized);
  }
  return writeCache(groups);
};

export const deleteCustomerGroup = async (id) => {
  if (isSupabaseConfigured) {
    try {
      await supabase.from("customer_groups").delete().eq("id", id);
    } catch (err) {
      console.warn("Failed to delete customer group from Supabase", err);
    }
  }

  const groups = readCache();
  const filtered = groups.filter((g) => g.id !== id);
  return writeCache(filtered);
};
